import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=45f9b0ae&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=45f9b0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9b0ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f9b0ae')) {
      api.createRecord('45f9b0ae', component.options)
    } else {
      api.reload('45f9b0ae', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=45f9b0ae&scoped=true&", function () {
      api.rerender('45f9b0ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qxQ48fZ0VYR9/JS/comp/PopupDialog.vue"
export default component.exports